(function () {
    angular.module('PWAPoCApp').factory('positionMarkerLayerFactory', positionMarkerLayerFactory);

    positionMarkerLayerFactory.$inject = [
        '$q',
        '$rootScope',
        'esriLoader',
        'mapUtility',
        'locationService'
    ];

    function positionMarkerLayerFactory(
        $q,
        $rootScope,
        esriLoader,
        mapUtility,
        locationService
    ) {
        const defaultCurrentPositionIconSize = 26;
        const rotationUpdateLimitKph = 5;

        let readyDeferred = null;

        let positionMarkerLayerFactory = {
            createLayerOnAdd: true,

            ready: function () {
                if (readyDeferred === null) {
                    readyDeferred = $q.defer();
                }

                return readyDeferred.promise;
            }
        };

        esriLoader.require([
            'esri/Graphic',
            'esri/geometry/Point',
            'esri/geometry/SpatialReference',
            'esri/symbols/PictureMarkerSymbol',
            'esri/layers/GraphicsLayer'
        ], function (Graphic, Point, SpatialReference, PictureMarkerSymbol, GraphicsLayer) {
            if (readyDeferred === null) {
                readyDeferred = $q.defer();
            }

            positionMarkerLayerFactory.createLayer = function () {
                let locationMarkerLayer = new GraphicsLayer();

                locationMarkerLayer.zIndex = 2;
                locationMarkerLayer.currentPosition = null;
                locationMarkerLayer.rotateMap = false;

                //Event handler functions
                locationMarkerLayer.locationChanged = function (evt, position) {
                    var self = locationMarkerLayer;
                    if (self.currentPosition && position && position.coords && mapUtility.hasPositionChanged(self.currentPosition, position)) {
                        if (position.coords.speed && position.coords.speed / 3.6 > rotationUpdateLimitKph) {
                            self.angle = position.coords.heading || mapUtility.getAngleDiff(self.currentPosition, position);
                        }

                        self.currentPosition = {
                            coords: {
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude
                            }
                        };

                        self.setPositionMarker(position, self.angle);
                    }
                }

                locationMarkerLayer.deactivateMarker = function() {
                    var self = locationMarkerLayer;
                    if (self.currentPosition && self.currentPosition.coords) {
                        self.setPositionMarker(self.currentPosition, self.angle, true);
                    }
                }

                locationMarkerLayer.mapRotationToggled = function (evt, rotateMap) {
                    var self = locationMarkerLayer;
                    if (rotateMap) {
                        self.setPositionMarker(self.currentPosition, self.angle);
                    }

                    self.rotateMap = rotateMap;
                }

                //Draw functions
                locationMarkerLayer.setPositionMarker = function(position, angle, expired) {
                    if (!position) return;

                    var self = locationMarkerLayer;

                    self.removeAll();

                    var positionGraphic = self.createCurrentPositionGraphic(position, angle, expired);
                    self.add(positionGraphic);
                }

                locationMarkerLayer.createCurrentPositionGraphic = function (currentPosition, angle, expired) {
                    var self = locationMarkerLayer;

                    if (typeof (angle) === 'undefined' || self.rotateMap) {
                        angle = 0;
                    }

                    var pictureMarkerSymbol = new PictureMarkerSymbol({
                        url: expired ? '../images/icons/map-marker-grayscale.png' : '../images/icons/map-marker.png',
                        width: defaultCurrentPositionIconSize,
                        height: defaultCurrentPositionIconSize,
                        declaredClass: 'position-marker'
                    });

                    pictureMarkerSymbol.angle = angle;

                    var pointGeometry = new Point(
                        currentPosition.coords.longitude,
                        currentPosition.coords.latitude,
                        new SpatialReference({ wkid: 4326 })
                    );

                    return new Graphic(pointGeometry, pictureMarkerSymbol);
                }

                //Set up event handlers
                $rootScope.$on('locationChanged', locationMarkerLayer.locationChanged);
                $rootScope.$on('locationExpired', locationMarkerLayer.deactivateMarker);
                $rootScope.$on('mapRotationToggled', locationMarkerLayer.mapRotationToggled);

                locationService
                    .getCurrentPosition()
                    .then(position => {
                        locationMarkerLayer.setPositionMarker(position, 0, true);
                        locationMarkerLayer.currentPosition = {
                            coords: {
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude
                            }
                        };
                    });

                return locationMarkerLayer;
            }

            readyDeferred.resolve(positionMarkerLayerFactory);
        });

        return positionMarkerLayerFactory;
    }
})();
